import * as React from 'react';
import Box from '@mui/material/Box';
import { makeStyles } from "@mui/styles";

const SignedInLayout: React.FC<SignedInLayoutProps> = (props) => {
    const styles = useStyles();

    return (
        <Box className={ styles.root }>
            <Box
                component="main"
                className={ styles.content }
            >
                { props.children }
            </Box>
        </Box>
    );
}
export default SignedInLayout;

export interface SignedInLayoutProps {
    readonly children?: any;
}

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        backgroundColor: theme.palette.primary.light,
    },
    content: {
        flexGrow: 1,
        height: '100vh',
        backgroundColor: theme.palette.primary.light,
        width: '100%',
        overflowY: 'scroll'
    },
}));

